const faviconUrl = new URL('/public/favicon.ico', import.meta.url).href;
const DEFAULT_PREVIEW_HASH = 'document';

export const htmlContent = (fileURL: string, fileName?: string): string => `
    <!DOCTYPE html>
    <html lang="uk">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${fileName || 'Перегляд документа'}</title>
        <link rel="icon" type="image/x-icon" href="${faviconUrl}">
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
            }
            html, body {
                width: 100%;
                height: 100%;
                overflow: hidden;
            }
            iframe {
                width: 100%;
                height: 100%;
                border: none;
            }
        </style>
    </head>
    <body>
        <iframe src="${fileURL}" title="${fileName || 'Документ'}"></iframe>
    </body>
    </html>
`;

export const buildPreviewHtmlUrl = (htmlURL: string, fileName?: string): string =>
  `${htmlURL}#${encodeURIComponent(fileName || DEFAULT_PREVIEW_HASH)}`;
